module.exports = __webpack_public_path__ + "static/img/PFK_Photo1_Slider_700x400.cf33c8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_Photo1_Slider_700x400.jpg
// module id = 338
// module chunks = 2